import { Component } from '@angular/core';

@Component({
  selector: 'app-delete-account-instructions',
  templateUrl: './delete-account-instructions.component.html',
  styleUrls: ['./delete-account-instructions.component.scss'],
})
export class DeleteAccountInstructionsComponent {}
